<ng-container
  *ngIf="
    currentRoute.includes('/used-tesla-for-sale');
    else sellMyTeslaTemplate
  "
>
  <section
    class="bg-[url('/assets/images/Group_73.webp')] bg-cover bg-center bg-blend-multiply bg-black/40 h-[50vh] xl:min-h-[40vh] flex justify-center items-center text-center text-white px-3"
  >
    <div class="space-y-2">
      <h1 class="text-4xl xl:text-5xl font-bold">
        Shop Used Tesla for Sale in <span>{{ location }}</span>
      </h1>
      <p>
        Find the best used Tesla for sale in {{ location }}. To Shop Now, click
        the button below
      </p>
      <a
        [routerLink]="'/used-tesla-for-sale'"
        [queryParams]="{
                  listingType: '!Sold',
                  location:
                    location.charAt(0).toUpperCase() +
                    location.slice(1).toLowerCase(),
                  OrderBy: 'created DESC',
                  Skip: 0,
                  Top: 9,
                }"
        class="bg-OUT-Blue hover:bg-blue-600 transition-colors duration-400 rounded-full px-4 py-2 text-white mt-3 inline-block"
      >
        Used Tesla For Sale in {{ location }}
      </a>
    </div>
  </section>
</ng-container>

<ng-template #sellMyTeslaTemplate>
  <section
    class="bg-[url('/assets/images/Cybertruck_65.webp')] bg-cover bg-center bg-blend-multiply bg-black/40 h-[50vh] xl:min-h-[40vh] flex justify-center items-center text-center text-white px-3"
  >
    <div class="space-y-2">
      <h1 class="text-4xl xl:text-5xl font-bold">
        Sell My Tesla {{ location }}. <span></span>
      </h1>
      <p class="font-semibold lg:text-lg">
        Get Nationwide exposure. To buy an ad click the button below.
      </p>
      <a
        routerLink="/sell-my-tesla"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 transition-colors duration-400 rounded-full px-4 py-2 text-white mt-3 inline-block"
      >
        Sell My Tesla
      </a>
    </div>
  </section>
</ng-template>
